export default class PageNavigationElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('page-navigation', PageNavigationElement);